import { LocalTime } from "@js-joda/core"

export const DAY_OF_WEEK_VALUES = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
] as const

export type DayOfWeek = (typeof DAY_OF_WEEK_VALUES)[number]

export type ReminderType = "measurement" | "medication"

export type ReminderDayTimeApiDto = {
  dayOfWeek: DayOfWeek
  time: string
  type: ReminderType
}

export type ReminderDayTime = {
  dayOfWeek: DayOfWeek
  time: LocalTime
  type: ReminderType
}

export const toReminderDayTime = (
  dto: ReminderDayTimeApiDto
): ReminderDayTime => ({
  ...dto,
  time: LocalTime.parse(dto.time),
})

export const toReminderDayTimeApiDto = (
  reminderDayTime: ReminderDayTime
): ReminderDayTimeApiDto => ({
  ...reminderDayTime,
  time: reminderDayTime.time.toString(),
})
